// 二次确认弹窗封装
function deleRows(type,prompt,title,icon,url,params,callback,callback1){
    var _this = window.Vue
    _this.$confirm(prompt, title, {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        closeOnClickModal:false,
        roundButton:true,
        type: icon,
        beforeClose:(action, instance, done)=>{
            done()
        }
    }).then(() => {
        _this.$api[type](url,params,res=>{
            callback(res)
            if(res.code && res.code == 200){
                _this.$message({
                    type: 'success',
                    duration:'2000',
                    message:'操作成功 ！'
                });
            }else{
                _this.$message({
                    type: 'error',
                    duration:'3000',
                    message:res.message || res.msg
                });
            }
        }, err =>{
            callback(err)
             _this.$message({
                type: 'error',
                duration:'3000',
                message:err
            });
        })
    }).catch(() => {
        if(callback1){
            callback1()
        }
        _this.$message({
            type: 'info',
            duration:'1000',
            message: '已取消操作 ！'
        });
    });
}
export default {
    confirmation:function(type,prompt,title,icon,url,params,callback,callback1){
        return deleRows(type,prompt,title,icon,url,params,callback,callback1)
    }
}


// WEBPACK FOOTER //
// ./src/assets/script/confirm.js